import { Input } from "@/components/ui/input";
import { MagnifyingGlass } from "@phosphor-icons/react";

/** Search input used by every list-oriented Settings tab. */
export function SearchBar({ value, onChange, placeholder, testId }) {
  return (
    <div className="relative">
      <MagnifyingGlass size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pl-9 pr-9 h-9"
        data-testid={testId}
        autoComplete="off"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange("")}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground text-xs px-1.5 py-0.5"
          data-testid={`${testId}-clear`}
          aria-label="Clear search"
        >
          Clear
        </button>
      )}
    </div>
  );
}

/** Small stat card used on the Relationships tab summary row. */
export function SummaryCard({ label, value, tone = "default" }) {
  const toneClass = {
    success: "bg-emerald-50 border-emerald-200",
    warn: "bg-amber-50 border-amber-200",
    muted: "bg-muted/40 border-border",
    default: "bg-card border-border",
  }[tone];
  return (
    <div className={`rounded-md border ${toneClass} p-3`}>
      <div className="overline text-muted-foreground">{label}</div>
      <div className="font-display text-2xl font-bold tabular-nums mt-1">{value}</div>
    </div>
  );
}
